// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"6686cc62","225":"338f4cbc","376":"5949840b","383":"104fa6db","403":"9f799aca","643":"a4667213","793":"2b24daa3"}[chunkId] + ".chunk.js";
};